// extracted by mini-css-extract-plugin
export var searchHeader = "_7x-0";
export var searchHeaderDark = "_7x-1";